import { getToken } from "#src/utils/getToken.ts";
import { isServer } from "#src/utils/isServer.ts";
import sleep from "#src/utils/sleep.ts";
import { createClient } from "graphql-ws";

export const subscriptionClient = isServer
  ? null
  : createClient({
      url:
        process.env.NEXT_PUBLIC_APP_ENDPOINT.replace("http", "ws") +
        "-subscribe",
      connectionParams: () => ({
        authToken: getToken(),
        referer: window.location.hostname,
      }),
      shouldRetry: () => true,
      retryAttempts: 5,
      retryWait: async (_retry) => {
        await sleep(10 * 1000);
        return;
      },
    });
